<ng-template #defaultTemplate let-label>
  <span *ngIf="label">{{ label }}</span>
  <ng-content select="[label]"></ng-content>
</ng-template>
<div class="input-checkbox" [style.margin-bottom]="messagePad" (click)="stopEventBubbling($event)">
  <div class="p-field">
    <label [for]="name" class="checkbox-label">
      <input
        #input
        appReadOnly
        type="checkbox"
        [id]="name"
        [attr.name]="name"
        [attr.data-cy]="dataCy"
        [checked]="value"
        [(ngModel)]="value"
        [disabled]="isDisabled"
        (click)="onValueChange()"
        #model="ngModel"
        [class.has-errors]="hasErrors"
        [class.disabled]="isDisabled"
        [tabindex]="tabindex !== undefined ? tabindex : ''"
        [attr.aria-invalid]="hasErrors"
        [attr.aria-describedby]="hasErrors ? name + '-error' : null"
        [attr.aria-controls]="aria?.controls"
        (blur)="blurEvent.emit($event)"
        (focus)="focusEvent.emit($event)"
        [ignoreReadOnly]="ignoreReadOnly"
      />
      <ng-container
        [ngTemplateOutlet]="optionTemplate || defaultTemplate"
        [ngTemplateOutletContext]="{ $implicit: label }"
      >
      </ng-container>
      <app-label-icon *ngIf="labelIcon" [data]="labelIcon" />
    </label>
    <div class="error-container" [attr.id]="name + '-error'" role="alert" aria-atomic="true">
      <span *ngFor="let error of errors" class="p-error">{{ error }}</span>
    </div>
  </div>
</div>
